import { FileExcelOutlined } from '@ant-design/icons';
import { App, Button, Card, Col, Row, Typography } from 'antd';
import { useState } from 'react';
import { apiDownload } from '../api/client';
import { periodLabel } from '../components/ui';
import { useWork } from '../features/context/WorkContext';

interface Report {
  key: string;
  title: string;
  desc: string;
  path: string;
  file: string;
  monthlyOnly?: boolean;
}

const REPORTS: Report[] = [
  {
    key: 'invoices',
    title: 'Bảng kê hóa đơn bán ra',
    desc: 'Toàn bộ hóa đơn đầu ra trong kỳ (gốc, điều chỉnh), kèm sheet tổng hợp theo thuế suất. Dùng đối chiếu tờ khai GTGT.',
    path: '/exports/invoices.xlsx',
    file: 'bang-ke-hd-ban-ra.xlsx',
  },
  {
    key: 'r1',
    title: 'Ngoại lệ đối soát R1',
    desc: 'Danh sách đơn thiếu, trùng, lệch tiền, lập trễ hóa đơn và trả hàng chưa điều chỉnh, kèm kết luận đã đóng.',
    path: '/exports/r1-exceptions.xlsx',
    file: 'ngoai-le-r1.xlsx',
    monthlyOnly: true,
  },
];

/** Xuất Excel (ExcelJS phía server) theo đúng ngữ cảnh đang chọn. */
export function ExportPage() {
  const w = useWork();
  const { message } = App.useApp();
  const [busy, setBusy] = useState<string | null>(null);
  const canExport = w.perms.has('acct.export');
  const monthly = /^\d{4}-\d{2}$/.test(w.period);

  const download = async (r: Report) => {
    setBusy(r.key);
    try {
      await apiDownload(`${r.path}?${w.query}`, r.file, { tenantId: w.tenant.id });
    } catch (e) {
      void message.error((e as Error).message);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="page">
      <Typography.Title level={4} className="page-title">
        Xuất Excel · {periodLabel(w.period)}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        Pháp nhân {w.entity.name} (MST {w.entity.taxCode}){w.shop ? `, shop ${w.shop.shopName}` : ', tất cả shop'}.
      </Typography.Paragraph>
      <Row gutter={[12, 12]}>
        {REPORTS.map((r) => (
          <Col key={r.key} xs={24} md={12}>
            <Card size="small" title={<><FileExcelOutlined style={{ color: '#15803D' }} /> {r.title}</>} style={{ height: '100%' }}>
              <Typography.Paragraph>{r.desc}</Typography.Paragraph>
              <Button
                type="primary"
                loading={busy === r.key}
                disabled={!canExport || (r.monthlyOnly && !monthly)}
                onClick={() => void download(r)}
              >
                Tải file .xlsx
              </Button>
              {r.monthlyOnly && !monthly && (
                <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
                  Chỉ xuất theo kỳ tháng
                </Typography.Text>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
